module.exports = __webpack_public_path__ + "static/clchc-ddb7c4e021297f37b35e2fe13fdc612f.jpg";